export default __webpack_public_path__ + "static/media/purpes 3.e553cb1b.png";